
import { Component, Prop, Vue } from "vue-property-decorator";
import AppLoading from "@/components/AppLoading.vue";

export enum ButtonColors {
  DEFAULT = "default",
  SECONDARY = "secondary",
  PRIMARY = "primary",
  GRADIENT = "gradient"
}

export enum ButtonSizes {
  DEFAULT = "default",
  SMALL = "small",
  LARGE = "large"
}

@Component({
  components: {
    AppLoading
  }
})
export default class AppButton extends Vue {
  @Prop({ type: String, required: false }) href!: string;
  @Prop({ type: Object, required: false }) to!: object;
  @Prop({ type: String, required: false, default: "button" }) type!: "button" | "submit" | "reset";
  @Prop({ type: String, required: false, default: ButtonColors.DEFAULT }) color!: ButtonColors;
  @Prop({ type: String, required: false, default: ButtonSizes.DEFAULT }) size!: ButtonSizes;
  @Prop({ type: Boolean, required: false, default: false }) loading!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;
  @Prop({ type: String, required: false }) tag!: boolean;

  get tagName() {
    return this.tag ?? "a";
  }
}
